import { render } from "./DailyMenuBanner.vue?vue&type=template&id=009c7ca8&scoped=true"
import script from "./DailyMenuBanner.vue?vue&type=script&lang=js"
export * from "./DailyMenuBanner.vue?vue&type=script&lang=js"

import "./DailyMenuBanner.vue?vue&type=style&index=0&id=009c7ca8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009c7ca8"]])

export default __exports__